import * as i0 from '@angular/core';
import { Directive, Input, HostListener, EventEmitter, Output, NgModule, Injectable, Inject, Pipe, Component } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALIDATORS } from '@angular/forms';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import * as i1$1 from 'ngx-permissions';
import * as i1$2 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import * as i1$3 from '@ngx-translate/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import * as i2 from '@angular/platform-browser';
import { trigger, transition, query, style, animate } from '@angular/animations';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';

class EnumValidator {
    validate(c) {
        console.log(c.value);
        if (!c.value) {
            return '';
        }
        const ENUM_REGEXP = /^[a-zA-Z]*$/;
        if (c.value && ENUM_REGEXP.test(c.value)) {
            return true;
        }
        else {
            return { enum: false };
        }
    }
}
EnumValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: EnumValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
EnumValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: EnumValidator, selector: "[appEnum]", inputs: { appEqual: "appEqual" }, providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EnumValidator,
            multi: true,
        },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: EnumValidator, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appEnum]',
                    providers: [
                        {
                            provide: NG_VALIDATORS,
                            useExisting: EnumValidator,
                            multi: true,
                        },
                    ],
                }]
        }], propDecorators: { appEqual: [{
                type: Input
            }] } });

class NohrefDirective {
    noop(event) {
        if (this.href.length === 0 || this.href === '#') {
            event.preventDefault();
        }
    }
}
NohrefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NohrefDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
NohrefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: NohrefDirective, selector: "[href]", inputs: { href: "href" }, host: { listeners: { "click": "noop($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NohrefDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line
                    selector: '[href]'
                }]
        }], propDecorators: { href: [{
                type: Input
            }], noop: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class OverlayLoadingDirective {
    constructor(elem, renderer) {
        this.elem = elem;
        this.renderer = renderer;
        this.overlayLoading = {};
        this.loadingDiv = null;
    }
    ngOnInit() {
        this.renderer.addClass(this.elem.nativeElement, 'overlay-loading-parent');
        this.loadingDiv = document.createElement('div');
        this.loadingDiv.className = 'overlay-loading';
        this.renderer.appendChild(this.elem.nativeElement, this.loadingDiv);
        if (this.overlayLoading) {
            this.renderer.setStyle(this.loadingDiv, 'display', 'block');
        }
    }
    ngOnChanges(changes) {
        if (changes.overlayLoading && this.loadingDiv) {
            if (this.overlayLoading) {
                this.renderer.setStyle(this.loadingDiv, 'display', 'block');
            }
            else {
                this.renderer.setStyle(this.loadingDiv, 'display', 'none');
            }
        }
    }
}
OverlayLoadingDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: OverlayLoadingDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
OverlayLoadingDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: OverlayLoadingDirective, selector: "[overlayLoading]", inputs: { overlayLoading: "overlayLoading" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: OverlayLoadingDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line
                    selector: '[overlayLoading]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { overlayLoading: [{
                type: Input
            }] } });

class TableSortDirective {
    constructor(elem, renderer) {
        this.elem = elem;
        this.renderer = renderer;
        this.sort = {};
        this.tableSort = {};
        this.tableSortChanged = new EventEmitter();
    }
    ngAfterViewInit() {
        this.sort = this.tableSort;
        this.applyChanges(this.sort.sortBy, true);
    }
    applyChanges(sortBy, init = false) {
        const children = Array.from(this.elem.nativeElement.children);
        children.forEach((item) => {
            if (!item.getAttribute('sortBy')) {
                return true;
            }
            this.renderer.removeClass(item, 'asc');
            this.renderer.removeClass(item, 'desc');
            if (!init &&
                this.sort.sortBy === sortBy &&
                item.getAttribute('sortBy') === this.sort.sortBy) {
                this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
            }
            if (item.getAttribute('sortBy') === sortBy) {
                if (this.sort.order === 'desc') {
                    this.renderer.addClass(item, 'desc');
                }
                else {
                    this.renderer.addClass(item, 'asc');
                }
            }
            if (init) {
                this.renderer.addClass(item, 'tableSortItem');
                this.renderer.addClass(item, 'cursor-pointer');
            }
        });
    }
    onClick($event) {
        const sortBy = $event.target.getAttribute('sortBy');
        if (!sortBy) {
            return true;
        }
        this.applyChanges(sortBy);
        this.sort.sortBy = sortBy;
        this.tableSortChanged.emit(this.sort);
    }
}
TableSortDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: TableSortDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
TableSortDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: TableSortDirective, selector: "[tableSort]", inputs: { sort: "sort", tableSort: "tableSort" }, outputs: { tableSortChanged: "tableSortChanged" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: TableSortDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line
                    selector: '[tableSort]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { sort: [{
                type: Input
            }], tableSort: [{
                type: Input
            }], tableSortChanged: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class NumbersOnlyDirective {
    constructor(el) {
        this.el = el;
    }
    onInput(value) {
        // NOTE: use NgControl patchValue to prevent the issue on validation
        this.el.control.patchValue(value.replace(/[^0-9]/g, ''));
    }
}
NumbersOnlyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NumbersOnlyDirective, deps: [{ token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
NumbersOnlyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.4", type: NumbersOnlyDirective, selector: "input[numbersOnly]", host: { listeners: { "input": "onInput($event.target.value)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NumbersOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[numbersOnly]'
                }]
        }], ctorParameters: function () { return [{ type: i1.NgControl }]; }, propDecorators: { onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }] } });

class NgxVenusDirectivesModule {
    static forRoot() {
        return { ngModule: NgxVenusDirectivesModule, providers: [] };
    }
}
NgxVenusDirectivesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusDirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxVenusDirectivesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusDirectivesModule, declarations: [EnumValidator,
        NohrefDirective,
        OverlayLoadingDirective,
        TableSortDirective,
        NumbersOnlyDirective], exports: [EnumValidator,
        NohrefDirective,
        OverlayLoadingDirective,
        TableSortDirective,
        NumbersOnlyDirective] });
NgxVenusDirectivesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusDirectivesModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusDirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        EnumValidator,
                        NohrefDirective,
                        OverlayLoadingDirective,
                        TableSortDirective,
                        NumbersOnlyDirective
                    ],
                    imports: [],
                    exports: [
                        EnumValidator,
                        NohrefDirective,
                        OverlayLoadingDirective,
                        TableSortDirective,
                        NumbersOnlyDirective
                    ]
                }]
        }] });

class StateService {
    constructor() {
        this.dataVar = null;
    }
    set data(data) {
        this.dataVar = data;
    }
    get data() {
        const temp = this.dataVar;
        //this.dataVar = null; 
        return temp;
    }
}
StateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: StateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: StateService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: StateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }] });

class StorageService {
    constructor(SystemConfig) {
        this.SystemConfig = SystemConfig;
        this.myCipher = null;
        this.myDecipher = null;
        this.cipher = salt => {
            let textToChars = text => text.split("").map(c => c.charCodeAt(0));
            let byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
            let applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
            return text => text
                .split("")
                .map(textToChars)
                .map(applySaltToChar)
                .map(byteHex)
                .join("");
        };
        this.decipher = salt => {
            let textToChars = text => text.split("").map(c => c.charCodeAt(0));
            let saltChars = textToChars(salt);
            let applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
            return encoded => encoded
                .match(/.{1,2}/g)
                .map(hex => parseInt(hex, 16))
                .map(applySaltToChar)
                .map(charCode => String.fromCharCode(charCode))
                .join("");
        };
        this.myCipher = this.cipher(this.SystemConfig.cipherKey || "j13FGw39L");
        this.myDecipher = this.decipher(this.SystemConfig.cipherKey || "j13FGw39L");
    }
    setData(key, data, type = "local") {
        const _data = this.myCipher(JSON.stringify(data));
        switch (type) {
            case "local":
                localStorage.setItem(key, _data);
                break;
            case "session":
                sessionStorage.setItem(key, _data);
                break;
        }
    }
    getData(key, type = "local") {
        let _data = "undefined";
        switch (type) {
            case "local":
                _data = localStorage.getItem(key);
                break;
            case "session":
                _data = sessionStorage.getItem(key);
                break;
        }
        if (_data && _data != "undefined") {
            if (!this.chipperChecker(_data)) {
                return JSON.parse(this.myDecipher(_data));
            }
            else {
                return JSON.parse(_data);
            }
        }
        else {
            return null;
        }
    }
    flush(key, type = "local") {
        switch (type) {
            case "local":
                localStorage.removeItem(key);
                break;
            case "session":
                sessionStorage.removeItem(key);
                break;
        }
    }
    chipperChecker(item) {
        try {
            JSON.parse(item);
            return true;
        }
        catch (error) {
            return false;
        }
    }
}
StorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: StorageService, deps: [{ token: "systemConfig" }], target: i0.ɵɵFactoryTarget.Injectable });
StorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: StorageService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ["systemConfig"]
                }] }]; } });

class AlertService {
    constructor() {
        this.onNoticeChanged$ = new ReplaySubject(null);
    }
    setNotice(message, type, isPopup) {
        this.onNoticeChanged$.next({
            message: message,
            type: type,
            isPopup: isPopup
        });
    }
}
AlertService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AlertService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AlertService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AlertService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AlertService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AuthService {
    constructor(SystemConfig, permissionsService, storageService, router) {
        this.SystemConfig = SystemConfig;
        this.permissionsService = permissionsService;
        this.storageService = storageService;
        this.router = router;
        this.isAuthorized$ = new BehaviorSubject(false);
    }
    authCheck() {
        const user = this.storageService.getData(this.SystemConfig.authServiceKey || "user", this.SystemConfig.authStorageType || "local");
        if (!user) {
            this.isAuthorized$.next(false);
        }
        else if (user && user.exp && user.exp < Date.now() / 1000) {
            this.isAuthorized$.next(false);
        }
        else {
            if (user.roles && user.roles.length) {
                this.permissionsService.addPermission(user.roles);
            }
            this.isAuthorized$.next(true);
        }
    }
    flush() {
        this.isAuthorized$.next(false);
        this.storageService.flush(this.SystemConfig.authServiceKey || "user", this.SystemConfig.authStorageType || "local");
        this.permissionsService.flushPermissions();
    }
    flushAndRedirect() {
        this.flush();
        this.router.navigate([this.SystemConfig.unauthorizedRedirectTo]);
    }
    set auth(data) {
        if (data.roles) {
            data.roles.push("AUTHORIZED");
        }
        else {
            data["roles"] = ["AUTHORIZED"];
        }
        this.storageService.setData(this.SystemConfig.authServiceKey || "user", data, this.SystemConfig.authStorageType || "local");
        this.authCheck();
    }
    get auth() {
        const _data = this.storageService.getData(this.SystemConfig.authServiceKey || "user", this.SystemConfig.authStorageType || "local");
        if (_data) {
            return _data;
        }
        else {
            return null;
        }
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AuthService, deps: [{ token: "systemConfig" }, { token: i1$1.NgxPermissionsService }, { token: StorageService }, { token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AuthService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ["systemConfig"]
                }] }, { type: i1$1.NgxPermissionsService }, { type: StorageService }, { type: i1$2.Router }]; } });

class LanguageService {
    constructor(SystemConfig, translate) {
        this.SystemConfig = SystemConfig;
        this.translate = translate;
    }
    langCheck() {
        const supportedLanguages = this.SystemConfig.supportedLanguages || [
            { code: "en", name: "English" }
        ];
        this.translate.addLangs(supportedLanguages.map(item => {
            return item.code;
        }));
        this.translate.setDefaultLang(supportedLanguages[0].code);
        const storedLang = localStorage.getItem("language");
        if (!storedLang) {
            const browserLang = this.translate.getBrowserLang();
            const lang = browserLang.match("/" +
                supportedLanguages
                    .map(item => {
                    return item.code;
                })
                    .join("|") +
                "/")
                ? browserLang
                : "en";
            this.translate.use(lang);
            localStorage.setItem("language", lang);
        }
        else {
            this.translate.use(storedLang);
        }
    }
    set language(lang) {
        this.translate.use(lang);
        localStorage.setItem("language", lang);
    }
    get languages() {
        return this.SystemConfig.supportedLanguages || [
            { code: "en", name: "English" }
        ];
    }
    get language() {
        return localStorage.getItem("language");
    }
}
LanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: LanguageService, deps: [{ token: "systemConfig" }, { token: i1$3.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
LanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: LanguageService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: LanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ["systemConfig"]
                }] }, { type: i1$3.TranslateService }]; } });

class RouteService {
    constructor(routeConfig, systemConfig, router, activatedRoute, browserTitle) {
        this.routeConfig = routeConfig;
        this.systemConfig = systemConfig;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.browserTitle = browserTitle;
        this.onRouteChange$ = new BehaviorSubject(null);
    }
    routeCheck() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .pipe(map(() => this.activatedRoute))
            .pipe(map((route) => {
            while (route.firstChild) {
                route = route.firstChild;
            }
            return route;
        }))
            .pipe(filter((route) => route.outlet === 'primary'))
            .pipe(mergeMap((route) => route.data))
            .subscribe((route) => {
            if (route && route['routeConfig']) {
                const data = this.routeConfig[route['routeConfig']];
                if (data.title && data.title.length > 0) {
                    this.browserTitle.setTitle(data.title);
                }
                else if (this.systemConfig.siteTitle) {
                    this.browserTitle.setTitle(this.systemConfig.siteTitle);
                }
                this.onRouteChange$.next(route);
            }
        });
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
}
RouteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: RouteService, deps: [{ token: 'routeConfig' }, { token: 'systemConfig' }, { token: i1$2.Router }, { token: i1$2.ActivatedRoute }, { token: i2.Title }], target: i0.ɵɵFactoryTarget.Injectable });
RouteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: RouteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: RouteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['routeConfig']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['systemConfig']
                }] }, { type: i1$2.Router }, { type: i1$2.ActivatedRoute }, { type: i2.Title }]; } });

class GoogleTagManagerService {
    constructor(SystemConfig) {
        this.SystemConfig = SystemConfig;
        this.isLoaded = false;
        this.browserGlobals = {
            windowRef() {
                return window;
            },
            documentRef() {
                return document;
            }
        };
        this.gtmId = this.SystemConfig.googleTagManagerId;
        this.gtmAuth = this.SystemConfig.googleTagManagerAuth;
        this.gtmPreview = this.SystemConfig.googleTagManagerPreview;
    }
    getDataLayer() {
        const window = this.browserGlobals.windowRef();
        window['dataLayer'] = window['dataLayer'] || [];
        return window['dataLayer'];
    }
    pushOnDataLayer(obj) {
        const dataLayer = this.getDataLayer();
        dataLayer.push(obj);
    }
    addGtmToDom() {
        const doc = this.browserGlobals.documentRef();
        this.pushOnDataLayer({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        const gtmScript = doc.createElement('script');
        gtmScript.id = 'GTMscript';
        gtmScript.async = true;
        gtmScript.src = this.applyGtmQueryParams('//www.googletagmanager.com/gtm.js');
        doc.head.insertBefore(gtmScript, doc.head.firstChild);
        const ifrm = doc.createElement('iframe');
        ifrm.setAttribute('src', this.applyGtmQueryParams('//www.googletagmanager.com/ns.html'));
        ifrm.style.width = '0';
        ifrm.style.height = '0';
        ifrm.style.display = 'none';
        ifrm.style.visibility = 'hidden';
        const noscript = doc.createElement('noscript');
        noscript.id = 'GTMiframe';
        noscript.appendChild(ifrm);
        doc.body.insertBefore(noscript, doc.body.firstChild);
        this.isLoaded = true;
    }
    pushTag(item) {
        if (!this.isLoaded) {
            this.addGtmToDom();
        }
        this.pushOnDataLayer(item);
    }
    applyGtmQueryParams(url) {
        const params = [`id=${this.gtmId}`];
        if (this.gtmAuth) {
            params.push(`gtm_auth=${this.gtmAuth}`);
        }
        if (this.gtmPreview) {
            params.push(`gtm_preview=${this.gtmPreview}`);
        }
        if (url.indexOf('?') === -1) {
            url += '?';
        }
        return url + params.join('&');
    }
}
GoogleTagManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: GoogleTagManagerService, deps: [{ token: 'systemConfig' }], target: i0.ɵɵFactoryTarget.Injectable });
GoogleTagManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: GoogleTagManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: GoogleTagManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['systemConfig']
                }] }]; } });

class Table {
    constructor(init = null) {
        this.loading = false;
        this.pageSizes = ['15', '30', '50', '100', '200'];
        this.metadata = {
            page: 1,
            pageSize: 15,
            totalPage: 0,
            totalItem: 0,
            sortBy: '',
            order: ''
        };
        this.records = [];
        Object.assign(this, init);
    }
    setPageSize(no) {
        this.metadata.page = 1;
        this.metadata.pageSize = +no;
    }
    set data(response) {
        this.loading = false;
        this.records = response.records;
        Object.assign(this.metadata, response.metadata);
    }
}

const fadeAnimation = trigger('fadeAnimation', [
    // The '* => *' will trigger the animation to change between any two states
    transition('* => *', [
        // The query function has three params.
        // First is the event, so this will apply on entering or when the element is added to the DOM.
        // Second is a list of styles or animations to apply.
        // Third we add a config object with optional set to true, this is to signal
        // angular that the animation may not apply as it may or may not be in the DOM.
        query(':enter', [
            style({
                opacity: 0,
                position: 'absolute',
                height: '100%',
                width: '100%'
            })
        ], { optional: true }),
        query(':leave', 
        // here we apply a style and use the animate function to apply the style over 0.3 seconds
        [
            style({
                opacity: 1,
                position: 'absolute',
                height: '100%',
                width: '100%'
            }),
            animate('0.3s', style({ opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
            style({
                opacity: 0,
                position: 'relative',
                height: '100%',
                width: '100%'
            }),
            animate('0.3s', style({ opacity: 1 }))
        ], { optional: true })
    ])
]);

class BeautifulEnumPipe {
    transform(value, args) {
        return value ? value.replace(/([a-z])([A-Z])/g, '$1 $2').trim().replace(/_/g, ' ')
            .toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ') : '';
    }
}
BeautifulEnumPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: BeautifulEnumPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BeautifulEnumPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: BeautifulEnumPipe, name: "beautifulEnum" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: BeautifulEnumPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'beautifulEnum'
                }]
        }] });

class TruncatePipe {
    transform(value, args1, args2) {
        const limit = args1 ? parseInt(args1, 10) : 10;
        const trail = args2 ? args2 : '...';
        return value.length > limit ? value.substring(0, limit) + trail : value;
    }
}
TruncatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: TruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TruncatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: TruncatePipe, name: "truncate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: TruncatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'truncate'
                }]
        }] });

class TranslateParamsPipe {
    transform(value, val1 = undefined, val2 = undefined, val3 = undefined, val4 = undefined, val5 = undefined) {
        const regex = new RegExp("${s}", "g");
        const regex2 = new RegExp("%s", "g");
        value = value.replace(regex, "#!T!#").replace(regex2, "#!T!#");
        if (val1) {
            value = value.replace("#!T!#", val1);
        }
        if (val2) {
            value = value.replace("#!T!#", val2);
        }
        if (val3) {
            value = value.replace("#!T!#", val3);
        }
        if (val4) {
            value = value.replace("#!T!#", val4);
        }
        if (val5) {
            value = value.replace("#!T!#", val5);
        }
        return value;
    }
}
TranslateParamsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: TranslateParamsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TranslateParamsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: TranslateParamsPipe, name: "translateParams" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: TranslateParamsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: "translateParams"
                }]
        }] });

class NgxVenusPipesModule {
    static forRoot() {
        return { ngModule: NgxVenusPipesModule, providers: [] };
    }
}
NgxVenusPipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusPipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxVenusPipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusPipesModule, declarations: [BeautifulEnumPipe,
        TruncatePipe,
        TranslateParamsPipe], exports: [BeautifulEnumPipe,
        TruncatePipe,
        TranslateParamsPipe] });
NgxVenusPipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusPipesModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusPipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BeautifulEnumPipe,
                        TruncatePipe,
                        TranslateParamsPipe,
                    ],
                    exports: [
                        BeautifulEnumPipe,
                        TruncatePipe,
                        TranslateParamsPipe,
                    ]
                }]
        }] });

class AlertComponent {
    constructor(alertService, changeDetectorRef) {
        this.alertService = alertService;
        this.changeDetectorRef = changeDetectorRef;
        this.type = '';
        this.message = '';
        this.alertTypes = {
            warning: {
                title: 'Warning!',
                class: 'alert alert-warning'
            },
            success: {
                title: 'Success!',
                class: 'alert alert-success'
            },
            info: {
                title: 'Info!',
                class: 'alert alert-info'
            }
        };
        this.alerts = [];
    }
    close(key) {
        const index = this.alerts.findIndex(el => el.key === key);
        if (index > -1) {
            this.alerts.splice(index, 1);
            this.changeDetectorRef.detectChanges();
        }
    }
    ngOnInit() {
        this.alertService.onNoticeChanged$.subscribe(notice => {
            if (this.alerts.findIndex(el => el.message === notice.message) > -1) {
                return;
            }
            const key = Math.random().toString(36).substring(7);
            this.alerts.push({
                message: notice.message || 'An unknown error occured.',
                type: notice.type,
                key: key
            });
            setTimeout(function () { this.close(key); }.bind(this), 5000);
            this.changeDetectorRef.detectChanges();
        });
    }
}
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AlertComponent, deps: [{ token: AlertService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.4", type: AlertComponent, selector: "ven-alert", ngImport: i0, template: "<div class=\"alert-container\">\r\n  <div *ngFor=\"let item of alerts;\" [ngClass]=\"alertTypes[item.type].class\" role=\"alert\" class=\"alert-styled-left alert-dismissible\">\r\n    <button type=\"button\" class=\"close\" (click)=\"close(item.key)\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n    <span class=\"font-weight-semibold mr-1\" [innerHtml]=\"alertTypes[item.type].title\"></span> <span [innerHtml]=\"item.message\"></span>\r\n  </div>\r\n</div>", styles: [".alert-container{position:fixed;z-index:999999;right:30px;top:80px;width:300px}.alert-container div{animation:slide-up .4s ease}@keyframes slide-up{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ven-alert', template: "<div class=\"alert-container\">\r\n  <div *ngFor=\"let item of alerts;\" [ngClass]=\"alertTypes[item.type].class\" role=\"alert\" class=\"alert-styled-left alert-dismissible\">\r\n    <button type=\"button\" class=\"close\" (click)=\"close(item.key)\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n    <span class=\"font-weight-semibold mr-1\" [innerHtml]=\"alertTypes[item.type].title\"></span> <span [innerHtml]=\"item.message\"></span>\r\n  </div>\r\n</div>", styles: [".alert-container{position:fixed;z-index:999999;right:30px;top:80px;width:300px}.alert-container div{animation:slide-up .4s ease}@keyframes slide-up{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}\n"] }]
        }], ctorParameters: function () { return [{ type: AlertService }, { type: i0.ChangeDetectorRef }]; } });

class NgxVenusComponentsModule {
    static forRoot() {
        return { ngModule: NgxVenusComponentsModule, providers: [] };
    }
}
NgxVenusComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxVenusComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusComponentsModule, declarations: [AlertComponent], imports: [CommonModule], exports: [AlertComponent] });
NgxVenusComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusComponentsModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.4", ngImport: i0, type: NgxVenusComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AlertComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        AlertComponent
                    ],
                    entryComponents: []
                }]
        }] });

/*
 * Public API Surface of ngx-venus
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertService, AuthService, BeautifulEnumPipe, EnumValidator, GoogleTagManagerService, LanguageService, NgxVenusComponentsModule, NgxVenusDirectivesModule, NgxVenusPipesModule, NohrefDirective, NumbersOnlyDirective, OverlayLoadingDirective, RouteService, StateService, StorageService, Table, TableSortDirective, TranslateParamsPipe, TruncatePipe, fadeAnimation };
